exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-e30530e0].el-tag.el-tag--success{background-color:#156140;border-color:#52e181;color:#fff}[data-v-e30530e0].el-tag.el-tag--warning{background-color:#526032;border-color:#cabb4f;color:#fff}[data-v-e30530e0].el-tag.el-tag--info{background-color:#20656d!important;border-color:#46a4af!important;color:#fff!important}.flow-tag[data-v-e30530e0]{position:relative;margin-bottom:30px;cursor:default}.flow-tag[data-v-e30530e0]:not(:last-child):after{content:\"\";position:absolute;left:50%;bottom:-31px;width:2px;height:30px;background-color:#ccc;-webkit-transform:translateX(-50%);transform:translateX(-50%)}", ""]);

// exports
